import script from "./NavigationIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationIcon.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationIcon.vue?vue&type=style&index=0&id=6f2d06b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2d06b5"]])

export default __exports__